import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await axios.post(`${API}/auth/forgot-password`, { email }); } catch { /* never leak */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8" data-testid="forgot-password-page">
        <h1 className="font-display text-2xl font-bold text-[#0B2447]">Forgot your password?</h1>
        {sent ? (
          <p className="mt-4 text-slate-600" data-testid="forgot-sent">
            If an account exists for <strong>{email}</strong>, we've emailed a link to reset your password. Please check your inbox (and spam folder).
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-sm text-slate-500">Enter your account email and we'll send you a secure link to set a new password.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
              data-testid="forgot-email" className="w-full border border-slate-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#0B2447]/30" />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full bg-[#0B2447] hover:bg-[#153461] text-white rounded-lg py-3 font-semibold disabled:opacity-50 transition-colors">
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-500"><Link to="/login" className="text-[#0B2447] font-semibold underline">Back to log in</Link></p>
      </div>
    </div>
  );
}
